import { Axios } from "../../axios.interceptor";

const h = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getSeoMeta    = (token)       => Axios.get("/api/v1/admin/seo", h(token));
export const upsertSeoMeta = (data, token) => Axios.post("/api/v1/admin/seo", data, h(token));
export const getSeoById    = (id, token)   => Axios.get(`/api/v1/admin/seo/${id}`, h(token));
export const updateSeoById = (id, data, token) => Axios.put(`/api/v1/admin/seo/${id}`, data, h(token));
export const deleteSeoMeta = (id, token)   => Axios.delete(`/api/v1/admin/seo/${id}`, h(token));
